import { Component, Input } from '@angular/core';
import { VideoFeed } from 'src/models/video-feed.model';
import { VideoStreamService } from 'src/app/services/video-stream.service';
import { Utility } from 'src/app/utils/app-utils';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ApiConstants } from 'src/app/constants/api-constants';
import {
	createRsePlayerControls,
	RsePlayerControlsState,
	toggleRseMuted,
	toggleRseObjectFit,
} from 'src/app/rse-player/rse-player-controls';

@Component({
	selector: 'app-sites-video-feeds',
	templateUrl: './sites-video-feeds.component.html',
	styleUrls: ['./sites-video-feeds.component.scss']
})
export class SitesVideoFeedsComponent {
	@Input() selectedBranch = null;
	public videoFeeds: VideoFeed[] = [];
	public selectedVideoFeed: any = null;
	public selectedVideoFeedNo: any = null;
	utility = Utility;
	readonly streamAppToken = ApiConstants.STREAM_APP_TOKEN;
	playerUi: RsePlayerControlsState = createRsePlayerControls();

	get streamEngineServerUrl(): string {
		return this.authenticationService.getUser()?.streamServerIP || '';
	}

	constructor(
		public videoStreamService: VideoStreamService,
		private authenticationService: AuthenticationService,
	) { }

	async ngOnChanges() {
		if (this.selectedBranch) {
			await this.loadVideoFeeds(this.selectedBranch.id);
		}
	}

	ngOnInit() {

	}

	ngOnDestroy() {
		this.selectedVideoFeed = null;
		this.videoStreamService.setEmptyVideoSources();
	}

	async loadVideoFeeds(branchId: string) {
		this.videoFeeds = [];
		this.selectedVideoFeed = null;
		this.videoFeeds = await this.videoStreamService.fetchVideoSourcesList(branchId, true);
		if (!this.videoFeeds) {
			this.videoFeeds = [];
		}

		// By default first video is shown
		this.selectedVideoFeed = this.videoFeeds.length > 0 ? this.videoStreamService.videoSourceOne : null;
		this.selectedVideoFeedNo = 0;
	}

	onVideoSelect(videoNo: number) {
		if (this.selectedVideoFeedNo === videoNo) {
			return;
		}

		// destroy the old player and start new one.
		this.selectedVideoFeed = null;
		// Allow angular to detect changes. It should destroy old player before starting new one.
		setTimeout(async () => {
			this.selectedVideoFeedNo = videoNo;
			await this.videoStreamService.setVideoSourceOne(videoNo);
			this.selectedVideoFeed = this.videoStreamService.videoSourceOne;
		}, 400);
	}

	asSourceUrl(url: string | string[]): string {
		return Array.isArray(url) ? (url[0] || '') : (url || '');
	}

	toggleMuted(event?: Event): void {
		toggleRseMuted(this.playerUi, event);
	}

	toggleObjectFit(event?: Event): void {
		toggleRseObjectFit(this.playerUi, event);
	}

}
